import { MenuAccessibilityController } from './header/menu-accessibility';
import { NavDefault } from './header/nav-default';

new MenuAccessibilityController();
new NavDefault();

window.onload = function() {
  // document.querySelector('.site-header__menu-trigger a').click();  
  // document.querySelector('#site-header-accessibility-trigger').click();  
}